import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStopBlueRedGreyed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 16,
	viewBox: "0 0 27 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7 2.5C7 1.125 10.125 0 14 0C17.9062 0 21 1.125 21 2.5V13C21 13.5625 20.5625 14 20 14V15C20 15.5625 19.5625 16 19 16H18C17.4688 16 17 15.5625 17 15V14H11V15C11 15.5625 10.5625 16 10 16H9C8.46875 16 8 15.5625 8 15V14H7.8125C7.3125 14 7 13.625 7 13.2188V2.5ZM18.5 12.5C19.0625 12.5 19.5 12.0625 19.5 11.5C19.5 10.9688 19.0625 10.5 18.5 10.5C17.9688 10.5 17.5 10.9688 17.5 11.5C17.5 12.0625 17.9688 12.5 18.5 12.5ZM18 9C18.5625 9 19 8.5625 19 8V4C19 3.46875 18.5625 3 18 3H10C9.46875 3 9 3.46875 9 4V8C9 8.5625 9.46875 9 10 9H18ZM9.5 12.5C10.0625 12.5 10.5 12.0625 10.5 11.5C10.5 10.9688 10.0625 10.5 9.5 10.5C8.96875 10.5 8.5 10.9688 8.5 11.5C8.5 12.0625 8.96875 12.5 9.5 12.5Z",
			fill: "#9e9e9e"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_317_1316",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 7,
			y: 0,
			width: 14,
			height: 16,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7 2.5C7 1.125 10.125 0 14 0C17.9062 0 21 1.125 21 2.5V13C21 13.5625 20.5625 14 20 14V15C20 15.5625 19.5625 16 19 16H18C17.4688 16 17 15.5625 17 15V14H11V15C11 15.5625 10.5625 16 10 16H9C8.46875 16 8 15.5625 8 15V14H7.8125C7.3125 14 7 13.625 7 13.2188V2.5ZM18.5 12.5C19.0625 12.5 19.5 12.0625 19.5 11.5C19.5 10.9688 19.0625 10.5 18.5 10.5C17.9688 10.5 17.5 10.9688 17.5 11.5C17.5 12.0625 17.9688 12.5 18.5 12.5ZM18 9C18.5625 9 19 8.5625 19 8V4C19 3.46875 18.5625 3 18 3H10C9.46875 3 9 3.46875 9 4V8C9 8.5625 9.46875 9 10 9H18ZM9.5 12.5C10.0625 12.5 10.5 12.0625 10.5 11.5C10.5 10.9688 10.0625 10.5 9.5 10.5C8.96875 10.5 8.5 10.9688 8.5 11.5C8.5 12.0625 8.96875 12.5 9.5 12.5Z",
				fill: "#9e9e9e"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_317_1316)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 7,
				height: 16,
				transform: "matrix(-1 0 0 1 21 0)",
				fill: "#9e9e9e"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_317_1316",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 6,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 6,
				height: 16,
				transform: "matrix(-1 0 0 1 6 0)",
				fill: "#9e9e9e"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_317_1316)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.5 3C3.6875 3 3 2.34375 3 1.5C3 0.6875 3.6875 0 4.5 0C5.34375 0 6 0.6875 6 1.5C6 2.34375 5.34375 3 4.5 3ZM8.71875 12.0625C8.8125 12.3125 8.96875 12.5625 9.15625 12.75L10.7188 14.3125C11.125 14.6875 11.125 15.3438 10.7188 15.7188C10.3438 16.125 9.6875 16.125 9.3125 15.7188L7.46875 13.875C7.25 13.6875 7.125 13.4375 7 13.1875L6.59375 12.125C8.3125 10.25 7.8125 10.8438 8.0625 10.4688L8.71875 12.0625ZM1.5625 7.6875L2.28125 7.3125L2.59375 6.375C3.0625 5 4.34375 4.03125 5.78125 4C6.90625 4 7.53125 4.34375 8.71875 4.8125C9.375 5.0625 9.9375 5.59375 10.25 6.25L10.4688 6.6875C10.7188 7.15625 10.5 7.78125 10.0312 8C9.53125 8.25 8.9375 8.0625 8.6875 7.5625L8.5 7.15625C8.375 6.9375 8.1875 6.75 7.96875 6.65625L7.125 6.3125L7.59375 8.21875C7.78125 8.875 7.59375 9.5625 7.15625 10.0625L5.28125 12.0938C5.03125 12.3438 4.875 12.6562 4.8125 12.9688L4.21875 15.25C4.09375 15.7812 3.5625 16.125 3.03125 16C2.5 15.8438 2.15625 15.3125 2.28125 14.7812L3 12C3.0625 11.6562 3.21875 11.375 3.4375 11.125L4.875 9.5625L4.34375 7.4375L4.15625 7.9375C4 8.4375 3.65625 8.875 3.1875 9.09375L2.4375 9.46875C1.96875 9.71875 1.375 9.5 1.125 9.03125C0.875 8.53125 1.0625 7.9375 1.5625 7.6875Z",
				fill: "#9e9e9e"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_317_1316",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 22,
			y: 0,
			width: 5,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 22,
				width: 5,
				height: 16,
				fill: "#9e9e9e"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_317_1316)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25.5 3C24.6875 3 24 2.34375 24 1.5C24 0.6875 24.6875 0 25.5 0C26.3438 0 27 0.6875 27 1.5C27 2.34375 26.3438 3 25.5 3ZM29.7188 12.0625C29.8125 12.3125 29.9688 12.5625 30.1562 12.75L31.7188 14.3125C32.125 14.6875 32.125 15.3438 31.7188 15.7188C31.3438 16.125 30.6875 16.125 30.3125 15.7188L28.4688 13.875C28.25 13.6875 28.125 13.4375 28 13.1875L27.5938 12.125C29.3125 10.25 28.8125 10.8438 29.0625 10.4688L29.7188 12.0625ZM22.5625 7.6875L23.2812 7.3125L23.5938 6.375C24.0625 5 25.3438 4.03125 26.7812 4C27.9062 4 28.5312 4.34375 29.7188 4.8125C30.375 5.0625 30.9375 5.59375 31.25 6.25L31.4688 6.6875C31.7188 7.15625 31.5 7.78125 31.0312 8C30.5312 8.25 29.9375 8.0625 29.6875 7.5625L29.5 7.15625C29.375 6.9375 29.1875 6.75 28.9688 6.65625L28.125 6.3125L28.5938 8.21875C28.7812 8.875 28.5938 9.5625 28.1562 10.0625L26.2812 12.0938C26.0312 12.3438 25.875 12.6562 25.8125 12.9688L25.2188 15.25C25.0938 15.7812 24.5625 16.125 24.0312 16C23.5 15.8438 23.1562 15.3125 23.2812 14.7812L24 12C24.0625 11.6562 24.2188 11.375 24.4375 11.125L25.875 9.5625L25.3438 7.4375L25.1562 7.9375C25 8.4375 24.6562 8.875 24.1875 9.09375L23.4375 9.46875C22.9688 9.71875 22.375 9.5 22.125 9.03125C21.875 8.53125 22.0625 7.9375 22.5625 7.6875Z",
				fill: "#9e9e9e"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgStopBlueRedGreyed);
export { ForwardRef as ReactComponent };
